(() => {
  if (window.__YIZCHO_ISLAND_MAIL_DEEPLINK_V01__) return;
  window.__YIZCHO_ISLAND_MAIL_DEEPLINK_V01__ = true;

  const TARGET_HASH = "#island-mail";
  const MAX_WAIT_MS = 10000;
  const RETRY_MS = 100;
  let retryStartedAt = 0;
  let retryTimer = 0;
  let opening = false;

  function clearRetry() {
    if (!retryTimer) return;
    window.clearTimeout(retryTimer);
    retryTimer = 0;
  }

  function consumeHash() {
    if (window.location.hash !== TARGET_HASH) return;
    const cleanUrl = new URL(window.location.href);
    cleanUrl.hash = "";
    window.history.replaceState(
      window.history.state,
      "",
      `${cleanUrl.pathname}${cleanUrl.search}`,
    );
  }

  function findManualTrigger() {
    return document.querySelector(".launch-house__kickstarter")
      || document.querySelector("#launch-product-cta")
      || document.querySelector("#mail-bird");
  }

  function scheduleRetry() {
    clearRetry();
    if (window.location.hash !== TARGET_HASH) return;
    if (!retryStartedAt) retryStartedAt = Date.now();
    if (Date.now() - retryStartedAt >= MAX_WAIT_MS) return;
    retryTimer = window.setTimeout(tryOpenFromHash, RETRY_MS);
  }

  function tryOpenFromHash() {
    if (window.location.hash !== TARGET_HASH || opening) return false;
    const trigger = findManualTrigger();
    const loading = document.querySelector(".loading");
    if (!trigger || loading) {
      scheduleRetry();
      return false;
    }

    opening = true;
    clearRetry();
    consumeHash();
    trigger.click();

    window.setTimeout(() => {
      if (!document.body.classList.contains("letter-open")) {
        document.querySelector("#mail-bird")?.click();
      }
      opening = false;
    }, 500);
    return true;
  }

  function begin() {
    retryStartedAt = Date.now();
    tryOpenFromHash();
  }

  window.addEventListener("hashchange", begin);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", begin, { once: true });
  } else {
    begin();
  }
})();
